import { Route, Routes } from 'react-router-dom';
import React, { lazy, Suspense } from 'react';
import { Login } from '../../components/login/login';
import { RequiredAuth } from '../auth/required-auth';
import { RouteNames } from './route-names';
import AthleteLogin from '../../components/login/athlete_login/athlete-login';
import { LoginCallback } from '@okta/okta-react';

const DashboardContent = lazy(() =>
  import('../../components/dashboard/dashboard').then(m => ({ default: m.DashboardContent })),
);
const Approvals = lazy(() =>
  import('../../components/approvals/approvals').then(m => ({ default: m.Approvals })),
);
const MyAccess = lazy(() =>
  import('components/myaccess/myaccess').then(m => ({ default: m.MyAccess })),
);
const Family = lazy(() => import('components/family/family').then(m => ({ default: m.Family })));

export const AppRoutes: React.FC = () => {
  return (
    <Suspense fallback={null}>
      <Routes>
        <Route path={RouteNames.LOGIN} element={<Login />}></Route>
        <Route path={RouteNames.CALLBACK} element={<LoginCallback />}></Route>
        <Route
          path={RouteNames.ATHLETE_LOGIN}
          element={<AthleteLogin onLoginTypeChange={null} onSuccessfulLogin={null} />}
        ></Route>
        <Route path="/" Component={RequiredAuth}>
          <Route path="/" element={<DashboardContent />} />
          <Route path={RouteNames.APPROVALS} element={<Approvals />} />
          <Route path={RouteNames.MYACCESS} element={<MyAccess />} />
          <Route path={RouteNames.FAMILY} element={<Family />} />
        </Route>
      </Routes>
    </Suspense>
  );
};
